import {
  DoorProduct,
  ExtraOptionScheme,
} from "app/providers/DoorOptionsProvider";
import { Fragment } from "react";

export const DrawerContent = ({ product }: { product: DoorProduct }) => {
  const {
    doorLayoutName,
    doorLayoutPrice,
    doorColorName,
    doorColorPrice,
    doorHandleName,
    doorHandlePrice,
    doorGlassName,
    doorGlassPrice,
    montageText,
    zelfMontagePrice,
    isSelfAssembly,
    extraOptions,
  } = product;

  return (
    <>
      <div className="gg-grid gg-auto-rows-min gg-grid-cols-2 gg-items-center gg-space-y-2.5 gg-text-dark-blue">
        {/* Layout */}
        <div className="gg-space-y-0">
          <h3 className="gg-mb-1 gg-text-sm gg-leading-tight">Ontwerp</h3>
          <p className="gg-text-xs gg-leading-tight gg-text-gray-500">
            {doorLayoutName}
          </p>
        </div>
        <div className="gg-justify-self-end gg-text-right gg-text-xs gg-leading-tight gg-text-gray-500">
          {doorLayoutPrice}
        </div>

        {/* Color */}
        <div className="gg-space-y-0">
          <h3 className="gg-mb-1 gg-text-sm gg-leading-tight">Kleur</h3>
          <p className="gg-text-xs gg-leading-tight gg-text-gray-500">
            {doorColorName}
          </p>
        </div>
        <div className="gg-justify-self-end gg-text-right gg-text-xs gg-leading-tight gg-text-gray-500">
          {doorColorPrice}
        </div>

        {/* Glas */}
        <div className="gg-space-y-0">
          <h3 className="gg-mb-1 gg-text-sm gg-leading-tight">Glas</h3>
          <p className="gg-text-xs gg-leading-tight gg-text-gray-500">
            {doorGlassName}
          </p>
        </div>
        <div className="gg-justify-self-end gg-text-right gg-text-xs gg-leading-tight gg-text-gray-500">
          {doorGlassPrice}
        </div>

        {/* Handle */}
        <div className="gg-space-y-0">
          <h3 className="gg-mb-1 gg-text-sm gg-leading-tight">Beslag</h3>
          <p className="gg-text-xs gg-leading-tight gg-text-gray-500">
            {doorHandleName}
          </p>
        </div>
        <div className="gg-justify-self-end gg-text-right gg-text-xs gg-leading-tight gg-text-gray-500">
          {doorHandlePrice}
        </div>

        {/* Extra opties */}
        <div className="gg-col-span-2 gg-space-y-0">
          <h3 className="gg-mb-1 gg-text-sm gg-leading-tight">Extra opties</h3>

          <ul className="gg-w-full gg-list-none gg-space-y-2">
            {extraOptions && extraOptions.length > 0 ? (
              extraOptions.map(
                (extraOption: ExtraOptionScheme, index: number) => {
                  const extraOptionPrice =
                    "€" +
                    (
                      (extraOption.price ?? 0) * (extraOption.amount || 1)
                    ).toFixed(2);
                  return (
                    <Fragment key={extraOption.id}>
                      <li className="gg-flex gg-justify-between gg-whitespace-nowrap">
                        <p className="gg-text-xs gg-leading-tight gg-text-gray-500">
                          - {extraOption.name}
                        </p>
                        <div className="gg-justify-self-end gg-text-right gg-text-xs gg-leading-tight gg-text-gray-500">
                          {extraOptionPrice}
                        </div>
                      </li>
                    </Fragment>
                  );
                },
              )
            ) : (
              <>-</>
            )}
          </ul>
        </div>

        {/* Montage */}

        <div className="gg-space-y-0">
          <h3 className="gg-mb-1 gg-text-sm gg-leading-tight">Montage</h3>
          <p className="gg-text-xs gg-leading-tight gg-text-gray-500">
            {montageText}
          </p>
        </div>
        {isSelfAssembly && (
          <div className="gg-justify-self-end gg-text-right gg-text-xs gg-leading-tight gg-text-green-300">
            - {zelfMontagePrice}
          </div>
        )}
      </div>
    </>
  );
};
